  <div style="margin: 25px; min-width: 1000px">
    <div class="estimation-tab-1">
      <h2 style="font-weight: bold">{{ 'costs_personnel' | translate }}</h2>
      @if (rateResult && rateResult['preparation'] && rateResult['follow-up'] && rateResult['execution']) {
        <div>
          <h3 class="subheader">{{ "budget.preparation" | translate }}</h3>
          @for (item of rateResult['preparation']; track item.name) {
            <div class="rateResult-list"
                 [ngStyle]="{'color': (item.hour === ('0 ' + this.hourText )) ? 'gray' : 'black'}">
              <h3 mat-line><b>{{ item.name }}</b></h3>
              <p mat-line> {{ "budget.spentTime" | translate }}:{{ item.hour }} </p>
              <p mat-line> {{ "budget.hourRate" | translate }}: {{ item.rate }} </p>
              <p mat-line><b>{{ item.data }}</b></p>
            </div>
          }
          <mat-divider></mat-divider>
          <h3 class="subheader">{{ "budget.execution" | translate }}</h3>
          @for (item of rateResult['execution']; track item.name) {
            <div class="rateResult-list"
                 [ngStyle]="{'color': (item.hour === ('0 ' + this.hourText )) ? 'gray' : 'black'}">
              <h3 mat-line><b>{{ item.name }}</b></h3>
              <p mat-line> {{ "budget.spentTime" | translate }}:{{ item.hour }} </p>
              <p mat-line> {{ "budget.hourRate" | translate }}:{{ item.rate }} </p>
              <p mat-line><b>{{ item.data }}</b></p>
            </div>
          }
          <mat-divider></mat-divider>
          <h3 class="subheader"> {{ "budget.follow-up" | translate }}</h3>
          @for (item of rateResult['follow-up']; track item.name) {
            <div class="rateResult-list"
                 [ngStyle]="{'color': (item.hour === ('0 ' + this.hourText )) ? 'gray' : 'black'}">
              <h3 mat-line><b>{{ item.name }}</b></h3>
              <p mat-line> {{ "budget.spentTime" | translate }}:{{ item.hour }} </p>
              <p mat-line> {{ "budget.hourRate" | translate }}:{{ item.rate }} </p>
              <p mat-line><b>{{ item.data }}</b></p>
            </div>
          }
        </div>
      }
    </div>
    <div class="estimation-tab-2" id="budgetResult1">
      <div style="display: block; width:70%; float:left">
        <h2 style="font-weight: bold">{{ 'budget.budget' | translate }}</h2>
        <button mat-icon-button disabled>
          <mat-icon (click)="printDiagram('budgetResult1')">print</mat-icon>
        </button>
        @if (totalBudget !== 0) {
          <div style="display: block; width:60%; float:left">
            <canvas mdbChart
                    [chartType]="chartType2"
                    [datasets]="chartDatasets2"
                    [labels]="chartLabels2"
                    [colors]="chartColors2"
                    [options]="chartOptions2"
                    [legend]="true"
                    (chartHover)="chartHovered($event)"
                    (chartClick)="chartClicked($event)">
            </canvas>
          </div>
        }
        @if (budgetData) {
          <div style="display: block; width:40%; float:left">
            <p><b>{{ 'budget.material' | translate }}:</b> {{ currency }} {{ budgetData.material }}.-</p>
            <p><b>{{ 'budget.meals' | translate }}:</b> {{ currency }} {{ budgetData.meals }}.-</p>
            <p><b>{{ 'budget.transport' | translate }}:</b>  {{ currency }} {{ budgetData.transport }}.-</p>
            <p><b>{{ 'budget.rents' | translate }}:</b> {{ currency }} {{ budgetData.miscellaneous }}.-</p>
            <p><b>{{ 'budget.miscellaneous' | translate }}:</b>  {{ currency }} {{ budgetData.rents }}.-</p>
          </div>
        }
        <div>
          <table style="border-collapse: collapse">
            <tr>
              <td><h2 style="font-weight: bold">{{ 'summary_total' | translate }}</h2></td>
            </tr>
            <tr>
              <td><span
                style="font-weight: bold; margin-right: 50px; font-size: 16px">{{ 'employee' | translate }}</span></td>
              <td></td>
            </tr>
            @for (item of adminResultData; track item.name) {
              <tr>
                <td><b> - {{ item.name }}:</b></td>
                <td>{{ currency }}  {{ item.rate }}.- / {{ item.hour }} {{ "budget.hourText" | translate }}</td>
              </tr>
            }
            <tr>
              <td><span
                style="font-weight: bold; margin-right: 50px; font-size: 16px">{{ 'budget.budget' | translate }}</span>
              </td>
              <td>{{ currency }} {{ totalBudget }}.-</td>
            </tr>
            <tr class="subTotalTrTop">
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><span
                style="font-weight: bold; margin-right: 50px; font-size: 16px">{{ 'subTotal' | translate }}</span></td>
              <td>{{ currency }} {{ budgetCost }}.-</td>
            </tr>
            <tr>
              <td><b>- {{ 'revenues' | translate }}</b></td>
              <td>{{ currency }} {{ (participantFriendCount * costFriend) + (participantNumber * cost) }}.-</td>
            </tr>
            <tr class="subTotalTrBottom">
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><span style="font-weight: bold; margin-right: 50px; font-size: 16px">{{ 'summe' | translate }}</span>
              </td>
              <td>{{ currency }} {{ budgetCost - ((participantFriendCount * costFriend) + (participantNumber * cost)) }}
                .-
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="revenues">
        <h2 style="font-weight: bold">{{ 'revenues' | translate }}</h2>
        <p><b>{{ "budget.participant" | translate }}:</b>  {{ participantNumber }}</p>
        <p><b>{{ "budget.coast" | translate }}:</b>  {{ currency }} {{ cost }}.-</p>
        <p><b>{{ "budget.total" | translate }}:</b>  {{ currency }} {{ (participantNumber * cost) }}.-</p>
        <br>
        <p><b>{{ "budget.participantFriend" | translate }}:</b>  {{ participantFriendCount }}</p>
        <p><b>{{ "budget.coastFriend" | translate }}:</b>  {{ currency }} {{ costFriend }}.-</p>
        <p><b>{{ "budget.totalFriend" | translate }}:</b>  {{ currency }} {{ (participantFriendCount * costFriend) }}.-
        </p>
        <br>
        <h3><b>{{ "budget.revenues" | translate }}
          :</b> {{ currency }}   {{ (participantFriendCount * costFriend) + (participantNumber * cost) }}.-</h3>
      </div>
    </div>
    <div style="width: 65%; float:left">
      <div style="display: block; width:50%; float:left">
        <canvas mdbChart
                [chartType]="chartType"
                [datasets]="chartDatasets"
                [labels]="chartLabels"
                [colors]="chartColors"
                [options]="chartOptions"
                [legend]="true"
                (chartHover)="chartHovered($event)"
                (chartClick)="chartClicked($event)">
        </canvas>
      </div>
      <div style="display: block; width:50%; float:left">
        <canvas mdbChart
                [chartType]="chartType"
                [datasets]="chartDatasets1"
                [labels]="chartLabels"
                [colors]="chartColors"
                [options]="chartOptions1"
                [legend]="true"
                (chartHover)="chartHovered($event)"
                (chartClick)="chartClicked($event)">
        </canvas>
      </div>
    </div>
  </div>




